import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    top: 2,
    alignSelf: 'flex-start',
    justifyContent: 'center',
  },
});



// WEBPACK FOOTER //
// ./src/components/third-party/Textfield/src/components/affix/styles.js